import React from 'react'
import cs from 'classnames'
import styles from 'elements/grail.scss'

const cloneWithClass = (elems, ...args) => {
	if (!elems) {return}
	const el = React.Children.only(elems)
	return React.cloneElement(el, {className: cs(el.props.className, ...args)})
}
// Performs flexbox Holy Grail layout
// elements must accept given classnames
const Grail = ({stretch, noScroll, header, children, content, nav, aside, footer, wrapperClass, extraClassName, extraContentClassName, ...rest}) => {
	const scrollStyle = noScroll || styles.scroll
	const stretchStyle = stretch && styles.stretch

	const headEl = cloneWithClass(header, styles.header)
	const navEl = cloneWithClass(nav, styles.nav)
	const contEl = cloneWithClass(children || content, styles.content, scrollStyle)
	const asideEl = cloneWithClass(aside, styles.aside)
	const footerEl = cloneWithClass(footer, styles.footer)
	return (
		<div {...rest} className={cs(styles.holyGrail, scrollStyle, stretchStyle, rest.className, extraClassName? extraClassName:'')}>
			{headEl}
			<div className={cs(styles.ieWrap, scrollStyle, styles.screenResizer, extraContentClassName)}>
				<div className={cs(styles.body, scrollStyle, wrapperClass)}>
					{contEl}
					{navEl}
					{asideEl}
				</div>
			</div>
			{footerEl}
		</div>
	)
}
export default Grail



// WEBPACK FOOTER //
// ./elements/Grail.jsx